import script from "./LinkTileGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkTileGrid.vue?vue&type=script&setup=true&lang=ts"

import "./LinkTileGrid.vue?vue&type=style&index=0&id=2d667657&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d667657"]])

export default __exports__